/*
  nibec-catalogo.js
  Dos piezas que el diseño del catálogo pide y Dawn no trae:

  1. <nibec-vista>      → toggle "Ver como" (grilla / lista), Figma 23:2827
  2. Slider de precio   → doble manija sobre los inputs del facets de Dawn, Figma 23:2816

  Ambas son MEJORA PROGRESIVA: sin este archivo la página filtra, ordena y pagina igual
  (los inputs de texto de Dawn siguen siendo la fuente de verdad; el slider ni se muestra).
*/

(function () {
  'use strict';

  /* ───────────────────────────────────────────────────────────
     1. Toggle de vista
     ───────────────────────────────────────────────────────────
     ⚠️ La clase modificadora va en #ProductGridContainer, NO en la <ul> de la grilla:
     facets.js reemplaza el innerHTML de #ProductGridContainer en cada filtro/orden, así
     que cualquier clase puesta adentro se pierde. El classList del propio contenedor
     sobrevive al reemplazo de su innerHTML. */

  var CLAVE_VISTA = 'nibec:catalogo:vista';

  function contenedorGrilla() {
    return document.getElementById('ProductGridContainer');
  }

  function aplicarVista(vista) {
    var cont = contenedorGrilla();
    if (cont) cont.classList.toggle('is-lista', vista === 'lista');
  }

  function vistaGuardada() {
    try {
      return window.localStorage.getItem(CLAVE_VISTA) || 'grilla';
    } catch (e) {
      /* Safari en modo privado tira SecurityError al tocar localStorage */
      return 'grilla';
    }
  }

  function guardarVista(vista) {
    try {
      window.localStorage.setItem(CLAVE_VISTA, vista);
    } catch (e) {
      /* sin persistencia, pero el toggle sigue funcionando en la sesión */
    }
  }

  class NibecVistaElement extends HTMLElement {
    connectedCallback() {
      this.botones = Array.prototype.slice.call(this.querySelectorAll('[data-vista]'));
      if (!this.botones.length) return;

      this.seleccionar(vistaGuardada(), false);

      this.botones.forEach(
        function (btn) {
          btn.addEventListener(
            'click',
            function () {
              this.seleccionar(btn.getAttribute('data-vista'), true);
            }.bind(this)
          );
        }.bind(this)
      );
    }

    seleccionar(vista, persistir) {
      this.botones.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-vista') === vista ? 'true' : 'false');
      });
      aplicarVista(vista);
      if (persistir) guardarVista(vista);
    }
  }

  if (!window.customElements.get('nibec-vista')) {
    window.customElements.define('nibec-vista', NibecVistaElement);
  }

  /* ───────────────────────────────────────────────────────────
     2. Slider de precio de doble manija
     ───────────────────────────────────────────────────────────
     El slider se INYECTA dentro del markup del snippet 'facets' de Dawn (que no se
     modifica). Como facets.js re-renderiza los .js-filter en cada cambio, el slider se
     destruye y hay que reconstruirlo: de eso se encarga el MutationObserver de abajo.
     Por eso no es un custom element — un elemento inyectado dentro de HTML reemplazado
     no sobrevive, y el ciclo de vida lo maneja el observer. */

  /* ⚠️ SEPARADOR DE MILES: SIEMPRE PUNTO, y NO el que use la tienda.
     Verificado contra el storefront (nibec-4, 11 productos):
       filter.v.price.lte=100000   → 6 de 11  ✅
       filter.v.price.lte=100.000  → 6 de 11  ✅
       filter.v.price.lte=100,000  → 0 de 11  ❌
     Shopify interpreta la COMA como separador DECIMAL, así que "100,000" vale 100.
     Y `money_without_currency` en esta tienda devuelve justo eso ("899,990" con coma,
     aunque `money` sí da "$899.990"), así que el valor que Shopify escribe de vuelta en
     el input NO es reenviable: es un bug preexistente del filtro de precio de Dawn acá.
     Arreglo de raíz: Admin → Configuración → General → formato de moneda "HTML sin
     moneda". Mientras no esté, este JS normaliza los inputs en cada render (ver
     construirSlider) para que nunca salga una coma en la query. */
  var SEPARADOR = '.';

  function aNumero(texto) {
    var digitos = String(texto || '').replace(/\D/g, '');
    return digitos === '' ? null : parseInt(digitos, 10);
  }

  function formatear(valor) {
    return String(valor).replace(/\B(?=(\d{3})+(?!\d))/g, SEPARADOR);
  }

  function pasoPara(max) {
    if (max > 100000) return 1000;
    if (max > 10000) return 100;
    return 1;
  }

  function construirSlider(priceRange) {
    var inputs = priceRange.querySelectorAll('input');
    if (inputs.length < 2) return;

    var inputMin = inputs[0];
    var inputMax = inputs[1];

    /* El techo del rango sale del placeholder del input máximo (lo pone Liquid con
       filter.range_max). Ojo: PriceRange de Dawn reescribe data-min/data-max de cada
       input según el valor del otro, así que el techo REAL se toma del placeholder,
       que Liquid siempre deja en filter.range_max. */
    var techo = aNumero(inputMax.getAttribute('placeholder'));
    if (techo === null) techo = aNumero(inputMax.getAttribute('data-max'));
    if (techo === null || techo <= 0) return;

    var paso = pasoPara(techo);
    var valMin = aNumero(inputMin.value);
    var valMax = aNumero(inputMax.value);

    /* NORMALIZACIÓN — cierra el bug de la coma para TODA la página, no solo para el
       slider: Shopify devuelve el valor filtrado con coma ("50,000"), y si el usuario
       después toca cualquier otro filtro, el form reenvía esa coma y trae 0 productos.
       Como esta función corre en cada render de facets.js, los inputs quedan siempre
       con un valor reenviable antes de que se pueda disparar el próximo submit. */
    if (valMin !== null) inputMin.value = formatear(valMin);
    if (valMax !== null) inputMax.value = formatear(valMax);

    if (valMin === null) valMin = 0;
    if (valMax === null) valMax = techo;

    var slider = document.createElement('div');
    slider.className = 'nibec-col__slider';
    slider.innerHTML =
      '<span class="nibec-col__slider-track"></span>' +
      '<span class="nibec-col__slider-activo"></span>' +
      '<input type="range" class="nibec-col__slider-min" min="0" max="' +
      techo +
      '" step="' +
      paso +
      '" value="' +
      valMin +
      '" style="z-index:3">' +
      '<input type="range" class="nibec-col__slider-max" min="0" max="' +
      techo +
      '" step="' +
      paso +
      '" value="' +
      valMax +
      '" style="z-index:2">';

    var rangoMin = slider.querySelector('.nibec-col__slider-min');
    var rangoMax = slider.querySelector('.nibec-col__slider-max');
    var activo = slider.querySelector('.nibec-col__slider-activo');

    /* Etiquetas accesibles: el slider duplica dos inputs que ya tienen su <label>
       ("Desde"/"Hasta"), así que se referencian por aria-label y se anuncia el valor
       con formato de moneda vía aria-valuetext. */
    var etiquetaMin = (inputMin.getAttribute('aria-label') || 'Precio mínimo').trim();
    var etiquetaMax = (inputMax.getAttribute('aria-label') || 'Precio máximo').trim();
    rangoMin.setAttribute('aria-label', etiquetaMin);
    rangoMax.setAttribute('aria-label', etiquetaMax);

    function pintar() {
      var a = Number(rangoMin.value);
      var b = Number(rangoMax.value);
      var izq = (a / techo) * 100;
      var der = (b / techo) * 100;
      activo.style.left = izq + '%';
      activo.style.width = Math.max(0, der - izq) + '%';
      rangoMin.setAttribute('aria-valuetext', formatear(a));
      rangoMax.setAttribute('aria-valuetext', formatear(b));
    }

    /* Las manijas no se cruzan */
    function normalizar(origen) {
      var a = Number(rangoMin.value);
      var b = Number(rangoMax.value);
      if (a > b) {
        if (origen === 'min') rangoMin.value = b;
        else rangoMax.value = a;
      }
    }

    /* Mientras se arrastra solo se actualiza el texto del input: NO se dispara evento.
       facets.js escucha 'input' en el form con 800ms de debounce, así que emitirlo en
       cada pixel dispararía una tanda de requests. El submit se dispara al soltar
       ('change'), con un solo evento 'input' burbujeante que es lo que el form espera. */
    function alArrastrar(origen) {
      normalizar(origen);
      pintar();
      var a = Number(rangoMin.value);
      var b = Number(rangoMax.value);
      inputMin.value = a > 0 ? formatear(a) : '';
      inputMax.value = b < techo ? formatear(b) : '';
    }

    function alSoltar() {
      /* Un solo 'input' burbujeante alcanza: el listener vive en el <form>. */
      inputMax.dispatchEvent(new Event('input', { bubbles: true }));
    }

    ['min', 'max'].forEach(function (cual) {
      var el = cual === 'min' ? rangoMin : rangoMax;
      el.addEventListener('input', function () {
        alArrastrar(cual);
      });
      el.addEventListener('change', alSoltar);
    });

    /* Si el usuario escribe en los inputs de texto, el slider se sincroniza */
    [inputMin, inputMax].forEach(function (el) {
      el.addEventListener('change', function () {
        var a = aNumero(inputMin.value);
        var b = aNumero(inputMax.value);
        rangoMin.value = a === null ? 0 : a;
        rangoMax.value = b === null ? techo : b;
        pintar();
      });
    });

    var contenedor = priceRange.parentNode;
    if (!contenedor) return;
    contenedor.insertBefore(slider, priceRange);
    priceRange.setAttribute('data-nibec-slider', 'on');
    pintar();
    /* .is-ready revela el slider: sin JS nunca se pinta y quedan solo los inputs */
    slider.classList.add('is-ready');
  }

  function asegurarSliders() {
    document.querySelectorAll('price-range').forEach(function (pr) {
      if (pr.getAttribute('data-nibec-slider') === 'on') return;
      construirSlider(pr);
    });
  }

  function iniciar() {
    var raiz = document.querySelector('.nibec-col');
    if (!raiz) return;

    asegurarSliders();
    aplicarVista(vistaGuardada());

    /* facets.js reemplaza el innerHTML de los .js-filter y de #ProductGridContainer;
       el observer reconstruye el slider y reaplica la vista después de cada render. */
    var observer = new MutationObserver(function () {
      asegurarSliders();
      aplicarVista(vistaGuardada());
    });

    observer.observe(raiz, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
